import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../static/logos/bellalite_black.svg'
import _imports_1 from '../../static/logos/bellalite_white.svg'
import _imports_2 from '../../static/icons/search-white-icon.svg'
import _imports_3 from '../../static/icons/cart_icon.svg'
import _imports_4 from '../../static/icons/menu_icon.svg'


const _hoisted_1 = { class: "phone-header__navigation" }
const _hoisted_2 = {
  key: 0,
  class: "phone-header__logo",
  src: _imports_0,
  alt: "Bellalite white logo"
}
const _hoisted_3 = {
  key: 1,
  class: "phone-header__logo",
  src: _imports_1,
  alt: "Bellalite white logo"
}
const _hoisted_4 = { class: "phone-header__content-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "phone-header__cart-button-count"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "phone-header__cart-icon",
  src: _imports_3
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "phone-header__spacer header__phone" }, null, -1)

import { inject, ref, computed } from 'vue';
import { isNavigationOpenKey, isSearchOpenKey, cartKey } from '@/keys';
import NavigationPhone from '@/components/NavigationPhone';
import useContext from '@/composables/useContext';


// //import PhoneHeaderMenu from "./PhoneHeaderMenu.vue";

// export default {
//   // components: {
//   //   PhoneHeaderMenu,
//   // },
//   emits: ["update:searchPhrase"],
//   data() {
//     return {
//       isMenuOpen: false,
//       currentMenuLayer: 0,
//       isSearchbarOpen: false,
//     };
//   },
//   inject: ["registerModal", "unregisterModal"],
//   computed: {
//     rootPath() {
//       return this.$channel.rootPath || "";
//     },
//   },
//   methods: {
//     getMenuContentHeight() {
//       return { minHeight: "100vh" };
//     },
//     closeMenu() {
//       this.unregisterModal();
//       this.isMenuOpen = false;
//     },
//     navigateForward() {
//       this.currentMenuLayer += 1;
//     },
//     navigateBackward() {
//       this.currentMenuLayer -= 1;
//     },
//   },
// };


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneHeader',
  setup(__props) {

const { mitt, environmentOptions } = useContext();
const siteId = environmentOptions.siteId;

const isNavigationOpen = inject(isNavigationOpenKey, ref(false));
const openMenu = () => {
  isNavigationOpen.value = true;
};

const isSearchOpen = inject(isSearchOpenKey, ref(false));

const toggleSearchbar = () => {
  mitt.emit(!isSearchOpen.value ? 'open-search-view' : 'close-search');
};

const cart = inject(cartKey);
const cartItemCount = computed(() =>
  (cart?.value?.rows || []).reduce((acc, curr) => acc + +curr.quantity, 0)
);

const openQuickCart = () => {
  mitt.emit('openQuickCart');
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps(_ctx.$attrs, { class: "phone-header header__phone" }), [
      _createElementVNode("div", _hoisted_1, [
        (_unref(siteId))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/",
              class: "phone-header__content-left"
            }, {
              default: _withCtx(() => [
                (_unref(siteId) === 'black')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                  : _createCommentVNode("", true),
                (_unref(siteId) === 'white')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "phone-header__search",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSearchbar()))
          }, _hoisted_6),
          _createElementVNode("div", {
            class: "phone-header__cart",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openQuickCart()))
          }, [
            (_unref(cartItemCount))
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(cartItemCount)), 1))
              : _createCommentVNode("", true),
            _hoisted_8
          ]),
          _createElementVNode("div", {
            class: "phone-header__menu",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openMenu()))
          }, _hoisted_10)
        ])
      ])
    ], 16),
    _hoisted_11,
    _createVNode(_unref(NavigationPhone))
  ], 64))
}
}

})